<template>
  <div>
    <v-dialog v-model="dialog" persistent width="700px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            2段階認証設定
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row class="mx-2" align="center" justify="center">
              <v-col cols="6">
                1. スマホのタイプに合わせて以下QRコードを読み込んで
                <a
                  href="https://support.google.com/accounts/answer/1066447?hl=ja"
                  target="_blank"
                  >Google 認証システム
                </a>
                をインストールしてください。（初回のみ）
              </v-col>
              <v-col cols="3">
                <img
                  src="../assets/authenticator_iphone.png"
                  style="width: 90px; margin: 5px 5px 0"
                />
                <p class="text-center" style="width: 90px; margin: 0 5px">
                  iPhone
                </p>
              </v-col>
              <v-col cols="3">
                <img
                  src="../assets/authenticator_android.png"
                  style="width: 90px; margin: 5px 5px 0"
                />
                <p class="text-center" style="width: 90px; margin: 0 5px">
                  Android
                </p>
              </v-col>
              <v-col cols="6">
                2. スマホのGoogle
                認証システム（Authenticator）で以下QRコードを読み込んでください。
              </v-col>
              <v-col cols="6">
                <img
                  :src="qrUrl"
                  alt="QRCode"
                  style="width: 90px; margin: 5px 5px 0"
                />
              </v-col>
              <v-col cols="6">
                3.
                スマホのGoogle認証システム（Authenticator）の画面上で表示される認証コードを入力してください。
              </v-col>
              <v-col cols="6">
                <div
                  class="position-relative"
                  style="padding-top: 20px; max-width: 300px"
                >
                  <v-otp-input
                    length="6"
                    v-model="form.code"
                    id="code"
                    :rules="rules.codeRules"
                    required
                  ></v-otp-input>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="gray">
            <v-spacer />
            <v-btn v-if="user.mfaFlag" color="error" class="px-4" elevation="2" @click="deleteDevice">
              無効化
            </v-btn>
            <v-btn v-if="!user.mfaFlag" color="primary" class="px-4" elevation="2" @click="saveDevice">
              有効化
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SetupDevice",
  data: () => ({
    form: {
      code: "",
    },
    qrUrl: "",
    dialog: false,
    valid: true,
    rules: {},
    codeRules: [(v) => !!v || "セキュリティコードは必須です"],
  }),
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.setRules();
  },
  mounted() {
    this.getQR();
  },
  methods: {
    open() {
      this.form.code = "";
      this.dialog = true;
    },
    /**
     * 検証ルールの設定
     */
    setRules() {
      this.rules = {
        codeRules: [this.$getValidate("required", "セキュリティコード")],
      };
    },
    async getQR() {
      const data = await this.$api.setupDevice().catch((error) => {
        console.log(error);
      });
      //console.log(data);
      this.qrUrl = data.msg;
    },
    async saveDevice() {
      if (this.$refs.form.validate()) {
        window.openLoading();
        const data = await this.$api.saveDevice(this.form).catch((error) => {
          console.log(error);
          window.closeLoading();
        });
        window.closeLoading();
        console.log(data);
        if (data && data.status == 200) {
          this.dialog = false;
        }
      }
    },
    async deleteDevice() {
      if (this.$refs.form.validate()) {
        window.openLoading();
        const data = await this.$api.deleteDevice(this.form).catch((error) => {
          console.log(error);
          window.closeLoading();
        });
        window.closeLoading();
        console.log(data);
        if (data && data.status == 200) {
          this.dialog = false;
        }
      }
    },
  },
};
</script>
